import { DocumentType, Maybe } from '@/globalTypes';

const fundingDocumentTypesMap: Record<string, true> = {
  [DocumentType.DividendsSOW]: true,
  [DocumentType.InheritanceSOW]: true,
  [DocumentType.SalarySOW]: true,
  [DocumentType.SaleOfCompanySOW]: true,
  [DocumentType.SaleOfPropertySOW]: true,
  [DocumentType.SourceOfWealth]: true,
};

export const isFundingDocument = (documentType: Maybe<DocumentType>) => {
  return !!(documentType && fundingDocumentTypesMap[documentType]);
};
